/**
 * Compara profundamente dois valores para verificar se são iguais.
 *
 * @param obj1 - Primeiro valor a ser comparado
 * @param obj2 - Segundo valor a ser comparado
 * @returns `true` se os valores são profundamente iguais, `false` caso contrário
 *
 * @remarks
 * - A ordem das propriedades em objetos não afeta o resultado
 * - A ordem dos elementos em arrays afeta o resultado
 * - Não lida com Dates, RegExp, Maps, Sets ou referências circulares
 */
export const compareObjects = (obj1: unknown, obj2: unknown): boolean => {
  if (obj1 === obj2) return true;

  if (
    typeof obj1 !== "object" ||
    typeof obj2 !== "object" ||
    obj1 === null ||
    obj2 === null
  ) {
    return obj1 === obj2;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false;

    return obj1.every((item, index) => compareObjects(item, obj2[index]));
  }

  if (Array.isArray(obj1) !== Array.isArray(obj2)) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every(
    key =>
      key in obj2 &&
      compareObjects(
        (obj1 as Record<string, unknown>)[key],
        (obj2 as Record<string, unknown>)[key]
      )
  );
};
